import Request from "./request";

const User = "/users";

export default {
  async getUser(query) {
    return Request.get(User, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getUserId(id) {
    return Request.get(`${User}/${id}/detail`);
  },
  async getUserRecomment(query) {
    return Request.get(User, {
      pageSize: query.pageSize,
      current: query.current
    });
  }
};
